// extracted by mini-css-extract-plugin
export default {"snackbars":"style_snackbars__Atnj4","snackbar":"style_snackbar__RBDQc","snackbar-container":"style_snackbar-container__BWH3D","snackbarContainer":"style_snackbar-container__BWH3D"};